export default __webpack_public_path__ + "static/media/saint-annes-track.cdec90c2.png";